<template>
	<div class="w-100">
		<div id="language"></div>
		<div class="position-relative z-index-1028">
      <div class="row no-gutters justify-content-center">
        <div class="fixed-top d-block nav-bottom">
          <div class="custom-container-fluid px-0">
            <div class="row justify-content-center no-gutters">
              <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
                <div class="bg-white" :class="{'box-shadow-nav':scrollPosition > 50}">
                  <div class="container px-4 w-100 pt-1 pb-2">
                    <div class="row no-gutters py-2 m-0 w-100">
                      <div class="col-1">
                        <div>
                          <router-link :to="'/'+getMerchant().code+'/concierge/account'">
                            <img src="../../../../assets/img/icon/back-arrow.png" class="mt-1 cursor-pointer" width="15">
                          </router-link>
                        </div>
                      </div>
                      <div class="col-8">
                        <div class="">
                          <p class="mb-0 body-1-2 nav-hotel ml-3 mt-1">{{$t('hotel.language')}}</p>
                        </div>
                      </div>
                      <div class="col-3 text-right">
                       <!--  <p class="mb-0 body-2-2 font-bold text-green mt-2 cursor-pointer text-16" v-else @click="toggleEdit(false)">Simpan</p> -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="margin-top: 80px"></div>
    <!-- <div class="container px-4">
      <div class="row slim-grid-row mb-2 pb-1 cursor-pointer" @click="toggleLanguage(data.code)" v-for="data in language">
        <div class="col-3 col-md-2">
          <img :src="data.img" class="w-100 position-relative top__language">
        </div>
        <div class="col-8 col-md-9">
          <p class="mb-0 body-2-2 text-16 font-bold">{{data.language}}</p>
          <p class="mb-0 body-2">{{data.name}}</p>
        </div>
        <div class="col-1 col-md-1">
          <div class="w-16px rounded-100 border-green position-relative" style="top: 10px">
            <div class="w-12px rounded-100 bg-green d-block mx-auto position-relative" v-if="getCurrentLanguage() == data.code" style="top: 1px"></div>
          </div>
        </div>
      </div>
    </div> -->
    <!-- LANGUAGE -->
    <Language v-if="is_language" :data="false" @toggleLanguage="toggleLanguage"></Language>
    <!-- POP UP BG -->
    <popUpBG v-if="is_language"></popUpBG>
  </div>
</template>
<script>
  import BottomNavbar from '@/components/hotel/BottomNavbar';
  import flag_united_states from '../../../../assets/img/icon/united-states.png'
  import flag_indonesia from '../../../../assets/img/icon/indonesia.png'
  import Language from '@/components/hotel/concierge/general/Language'
  import popUpBG from '@/components/hotel/concierge/general/popUpBG'
  import {mapGetters,mapMutations} from "vuex";

  export default{
    metaInfo(){
      return {
        title: 'Language',
        titleTemplate: this.getMetaTitleTemplate()
      }
    },
    components:{
      BottomNavbar,
      Language,
      popUpBG
    },
    data(){
      return{
        scrollPosition: null,
        is_language: true,
        language_selected: '',
        language: [
          {
            code: 'en',
            name: 'United States',
            language: 'English',
            img: flag_united_states,
            status: 'active'
          },
          {
            code: 'id',
            name: 'Indonesia',
            language: 'Bahasa Indonesia',
            img: flag_indonesia,
            status: 'active'
          }
        ]
      }
    },
    computed:{
    },
    mounted() {
      window.addEventListener('scroll', this.updateScroll);
      document.getElementById('language').scrollIntoView({
        behavior: 'smooth'
      });
    },
    methods:{
      ...mapGetters(['getMerchant', 'getCurrentLanguage','getMetaTitleTemplate']),
      ...mapMutations(['setLanguageMutation']),
      updateScroll() {
          this.scrollPosition = window.scrollY
      },
      toggleLanguage(data){
        this.language_selected = data
        this.setLanguageMutation(this.language_selected)
        window.location.reload()
      },
      toggleLanguage(data){
        if (data == false) {
          this.$router.push({
            path:'/'+this.getMerchant().code+'/concierge/account'
          })
        }
      }
    }
  }
</script>
<style scoped>
  .top__language{
    top: -5px
  }

  @media screen and (max-width: 655px) {
    .top__language{
      top: -10px!important
    }    
  }

</style>


// WEBPACK FOOTER //
// src/pages/hotel/concierge/account/Language.vue